import "./Tuyendung.css";
export default function Sticky() {
  return (
    <div className="sticky-cta">
      <a href="https://forms.gle/vUrDG86ZUsm3DNgm8" target="_blank" rel="noreferrer">
        Điền form ứng tuyển — Lương 15tr+
      </a>
    </div>
  );
}